<template>
  <div>
    <b-card>
      <!-- Header: Personal Info -->
      <div class="d-flex">
        <feather-icon
          icon="MapIcon"
          size="20"
        />
        <h4 class="mb-0 ml-50">
          Create Site
        </h4>
      </div>

      <!-- Form: Personal Info Form -->
      <b-form class="mt-1">
        <b-row>
          <!-- Field: Mobile -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Site"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="userDataInfo.areaName"
              />
            </b-form-group>
          </b-col>
          <!-- Field: Mobile -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Description"
              label-for="description"
            >
              <b-form-textarea
                id="description"
                v-model="userDataInfo.description"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <!-- Field: Address -->
          <!-- <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Address"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="userDataInfo.address"
              />
            </b-form-group>
          </b-col> -->
           <!-- Field: Pic Name -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="PIC Name"
              label-for="pic-name"
            >
              <b-form-input
                id="pic-name"
                v-model="userDataInfo.pic_name"
              />
            </b-form-group>
          </b-col>
           <!-- Field: Pic Contact -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="PIC Phone"
              label-for="pic-contact"
            >
              <b-form-input
                id="pic-contact"
                type="number"
                v-model="userDataInfo.pic_contact"
              />
            </b-form-group>
          </b-col>
           <!-- Field: Pic Email -->
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="PIC Email"
              label-for="pic-email"
            >
              <b-form-input
                id="pic-email"
                type="email"
                v-model="userDataInfo.pic_email"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              label="Status"
              label-for="Status"
            >
              <v-select
                v-model="userDataInfo.status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="status"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col>
            <b-button
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              :disabled="isSubmitted"
              @click="submitUser"
            >
              Submit
            </b-button>
            <!-- <b-button
              variant="danger"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            >
              Cancel
            </b-button> -->
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BCard, BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import axios from '@axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BCard,
    BFormTextarea,
    vSelect,
  },
  setup() {
    // Use toast
    const toast = useToast()

    const userDataInfo = ref({
      areaName: '',
      description: '',
      // address: '',
      pic_name: '',
      pic_contact: '',
      pic_email: '',
      status: '',
    })

    const isSubmitted = false

    const statusOptions = [
      { label: 'Enabled', value: 1 },
      { label: 'Disabled', value: 0 },
    ]

    return {
      userDataInfo,
      statusOptions,
      required,
      toast,
      isSubmitted,
    }
  },
  methods: {
    submitUser() {
      this.isSubmitted = true
      axios
        .post(`${this.$store.state.customConfig.baseURL}/web/area/create`, {
          apikey: this.$store.state.customConfig.token,
          name: this.userDataInfo.areaName,
          status: `${this.userDataInfo.status}`,
          description: this.userDataInfo.description,
          pic_name: this.userDataInfo.pic_name,
          pic_phone: this.userDataInfo.pic_contact,
          pic_email: this.userDataInfo.pic_email,
        }, {
          headers: { 'Access-Control-Allow-Origin': '*' },
        })
        .then(responseUser => {
          if (responseUser) {
            this.$router.replace('/masterdata/area')
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Create Area submitted',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: 'You have successfully submitted an Area',
                },
              })
            })
          }
          
        })
        .catch(error => {
          if (error) {
            this.isSubmitted = false
            alert("Create Area Gagal")
          }
          // this.$refs.loginForm.setErrors(error.response.data.error)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
